module.exports = __webpack_public_path__ + "static/media/draw-accept-request.08f6d0cc.svg";